import { SimpleAttributePermissionCoreBase } from "./simple-attribute-permission.core.base"


export class SimpleAttributePermissionCore extends SimpleAttributePermissionCoreBase {

}